export default __webpack_public_path__ + "static/media/congrats.b0f71e84.svg";